import React, { useState } from 'react';
import axios from 'axios';
//import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
/* import {
    MDBContainer,
    MDBInput,
    //MDBBtn,
} from 'mdb-react-ui-kit'; */

function LoginNewAcct() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const history = useNavigate();

    

    const handleLogin = async () => {
        try {
            if (!username || !password) {
                setError('Please enter both username and password.');
                return;
            }
            const apiUrl = process.env.REACT_APP_API_URL;
            // const response = await axios.post(`${apiUrl}:8080/users/login`, { username, password });
            const response = await axios.post('http://muvitapp.com/webapp1/', { username, password });
            console.log('Login successful with JWT token granted:', response.data);
            
            
            if (response.data) {
                
                sessionStorage.setItem('jwtToken', response.data);
                console.log('JWT token saved');
                sessionStorage.setItem('sessionusername', username);
                console.log('sesssion username: ', username);
              } else {
                console.log('Login failed');
              }
            
               
           // history('/dashboard');
           history('/dashboard');

        } catch (error) {
            console.error('Login failed:', error.response ? error.response.data : error.message);
            setError('Invalid username or password.');
        }
    };

    return (
        <div className="d-flex justify-content-center align-items-center vh-100">
            <div className="border rounded-lg p-4" style={{ width: '500px', height: 'auto' }}>

                    <h2 className="mb-4 text-center">Account Successfully Created. Please check your email for account verification link.</h2>
                   
                    
            </div>
        </div>
    );
}

export default LoginNewAcct;